import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

@Injectable({
  providedIn: 'root',
})
export class GenerateVcodeService extends Mutation {
  document = gql`
    mutation GenerateVcode ($email: String!) {
        generateVcode(email: $email)
    }
    `;
  }
